import React from 'react';
import './cta.css';

const CTA = () => (
  <section className="gpt3__cta">
    <div className="gpt3__cta-content">
      <p>Request Early to Get Discounted Services</p>
      <h3>Seamless Solutions, Just a Click Away: Book our services and enjoy a hassle-free experience.</h3>
    </div>
    <div className="gpt3__cta-btn">
      {/* Example of file upload, uncomment if needed */}
      {/* <div>
        <input type="file" accept="image/*" onChange={handleChange} aria-label="Upload File" />
        <button onClick={handleUpload} type="button">Upload to Firebase</button>
        <p>{percent}% done</p>
      </div> */}
      <button type="button"><a href="/#portfolio">See Portfolio</a></button>
    </div>
  </section>
);

export default CTA;

